import axios from "axios";
import {
  createContext,
  ReactChild,
  useCallback,
  useReducer,
  useState,
} from "react";
import { toast } from "react-toastify";
import { RequestAccountType } from "../../types/Types";
import { getError } from "../../utils/getError.utils";
import ActionTypes from "../Action.types";
import { RequestAccountsReducer } from "./RequestAccounts.reducer";

export const RequestAccountsContext = createContext({
  requestState: {
    requests: [] as RequestAccountType[],
    isLoading: false,
  },
  createRequest: (type: string, quantity: number, accessToken: string) => {},
  findAllRequest: (status: string) => {},
  findWithUserId: (requestAccount: RequestAccountType) => {},
  deleteRequest: (id: string, role: string) => {},
  updateRequest: (request: RequestAccountType) => {},
  requestAlert: [] as RequestAccountType[],
});

interface RequestProps {
  children: ReactChild;
}

const INITIAL_STATE = {
  requests: [] as RequestAccountType[],
  isLoading: false,
};

const RequestAccountsProvider = ({ children }: RequestProps) => {
  const [state, dispatch] = useReducer(RequestAccountsReducer, INITIAL_STATE);

  const [requestAlert, setRequestAlert] = useState<RequestAccountType[]>([]);

  const findAllRequest = useCallback(async (status: string) => {
    dispatch({ type: ActionTypes.start, payload: "" });
    const alert = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/requset-accounts?status=1`
    );

    setRequestAlert(alert.data);

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/requset-accounts?status=${status}`
    );

    dispatch({ type: ActionTypes.find, payload: res.data });
  }, []);

  const findWithUserId = useCallback(
    async (requestAccount: RequestAccountType) => {
      dispatch({ type: ActionTypes.find, payload: requestAccount });
      // dispatch({ type: ActionTypes.start, payload: '' });
      // const res = await axios.get(
      //   `${process.env.REACT_APP_BACKEND_URL}/requset-accounts/findWithUserId?status=${status}`,
      //   {
      //     headers: { authorization: 'Bearer ' + accessToken },
      //   }
      // );
      // dispatch({ type: ActionTypes.find, payload: res.data });
    },
    []
  );

  const createRequest = async (
    type: string,
    quantity: number,
    accessToken: string
  ) => {
    dispatch({ type: ActionTypes.start, payload: "" });
    try {
      if (isNaN(quantity)) {
        toast.error("Quantity must me number.");
        dispatch({ type: ActionTypes.clear, payload: "" });
        return;
      }

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/requset-accounts/check-quantity?type=${type}`
      );

      // if (data < quantity) {
      //   toast.warn(`Sorry, Accounst is out of stock.`);
      //   dispatch({ type: ActionTypes.clear, payload: '' });
      //   return;
      // }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/requset-accounts/create-request`,
        { type, quantity },
        {
          headers: { authorization: "Bearer " + accessToken },
        }
      );

      dispatch({ type: ActionTypes.create, payload: res.data });
      toast.success("Create request is successfully.");
    } catch (error: any) {
      dispatch({ type: ActionTypes.error, payload: "" });
      toast.error(`${getError(error)}`);
    }
  };

  const updateRequest = async (request: RequestAccountType) => {
    try {
      const update = state.requests
        .map((req) => (req._id === request._id ? { ...request } : req))
        .filter((req) => req.status === "1");

      setRequestAlert(update);

      dispatch({ type: ActionTypes.update, payload: request });
    } catch (error: any) {
      toast.error(`${getError(error)}`);
    }
  };

  const deleteRequest = async (id: string, role: string) => {
    dispatch({ type: ActionTypes.start, payload: "" });
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/requset-accounts/findWithRequestId/${id}`
      );

      if (res.data.status === "2" && +role <= 2) {
        toast.error("Can't delete this request.");
        dispatch({ type: ActionTypes.clear, payload: "" });
        return;
      }

      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/requset-accounts/${id}`,
        {
          headers: { authorization: "Bearer " + userData.accessToken },
        }
      );

      const deleteData = requestAlert.filter((req) => req._id !== id);

      setRequestAlert(deleteData);

      dispatch({ type: ActionTypes.delete, payload: data });
      toast.success("Delete request is successfully.");
    } catch (error: any) {
      dispatch({ type: ActionTypes.error, payload: "" });
      toast.error(`${getError(error)}`);
    }
  };

  return (
    <RequestAccountsContext.Provider
      value={{
        requestState: state,
        findAllRequest,
        findWithUserId,
        createRequest,
        deleteRequest,
        updateRequest,
        requestAlert,
      }}
    >
      {children}
    </RequestAccountsContext.Provider>
  );
};

export default RequestAccountsProvider;
